import { render, staticRenderFns } from "./ModalOpcoes.vue?vue&type=template&id=3942a93c&scoped=true&lang=pug"
import script from "./ModalOpcoes.vue?vue&type=script&lang=js"
export * from "./ModalOpcoes.vue?vue&type=script&lang=js"
import style0 from "./ModalOpcoes.vue?vue&type=style&index=0&id=3942a93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942a93c",
  null
  
)

export default component.exports